export default "__VITE_ASSET__Czr832dE__"